import React, { useCallback, useRef, useState } from 'react';
import FormSubmit from '../../common/form/FormSubmit';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { validateFile } from '../../../utils/upload-files/validateFile';
import { usePostProductsUploadMutation } from '../../../services/api/repositories/ProductsRepository';

export default function ProductsSection() {

    const fileRef = useRef<HTMLInputElement | null>(null);

    const [postProductsUpload , {isLoading, isSuccess, isError, data }] = usePostProductsUploadMutation();

    const [errors, setErrors] = useState<string[]>([]);
    const [show, setShow] = useState(false);

    const handleClose = useCallback(() =>{
        setShow(false)
    }, [setShow]);

    const handleShow = useCallback(async() =>{
        if (!fileRef.current?.files) {
            return;
        }

        if(fileRef.current.files[0] === undefined
            || fileRef.current.files === null
        ){
            setErrors(['Veuillez sélectionner un fichier']);
            return;
        }

        if(fileRef.current.files[0].size === 0){
            setErrors(['Le fichier est vide']);
            return;
        }
            

        const validationErrors = await validateFile(fileRef.current.files[0], ['.XLSX', 'XLSX', '.xlsx', 'xlsx'], 100);
        
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors([]);
        setShow(true)
    }, [setShow]);

    const handleSubmit = useCallback(async () =>{
        if (!fileRef.current?.files) {
            return;
        }

        if(fileRef.current.files[0] === undefined
            || fileRef.current.files[0] === null
            || fileRef.current.files[0].name === undefined
            || fileRef.current.files[0].size === undefined
        ){
            setErrors(['Veuillez sélectionner un fichier']);
            return;
        }

        if(fileRef.current.files[0].size === 0){
            setErrors(['Le fichier est vide']);
            return;
        }

        const validationErrors = await validateFile(fileRef.current.files[0], ['.XLSX', 'XLSX', '.xlsx', 'xlsx'], 100);
        
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors([]);
        postProductsUpload({file: fileRef.current?.files[0] as File});
        setShow(false);
    }, [fileRef, postProductsUpload, setErrors, setShow]);


    return (
        <>
            <div className="object articles">
                <Form>
                    <Form.Group className="form-group" >
                        <Form.Label>
                            Fichier Base Articles
                        </Form.Label>
                        <Form.Control
                            type="file"
                            className="form-control w100"
                            id="articles-file-input"
                            tabIndex={1}
                            placeholder=""
                            ref={fileRef}
                        />
                        <p className="form-help">'Fichier au format .xlsx'</p>
                        {errors.map((error, index) => (
                            <p key={index} className="form-error">{error}</p>
                        ))}
                        {(isSuccess || isError)&& <p className="form-success">{data?.message}</p>}
                        {isLoading && <p className="form-loading">Chargement...</p>}
                    </Form.Group>
                    <FormSubmit>
                        <Button
                            className='btn btn-primary btn-import'
                            title="Importer le fichier"
                            onClick={() => {handleShow()}}
                        >
                            <span className="icon"></span>
                            Importer
                        </Button>
                    </FormSubmit>
                </Form>
            </div>

            <Modal id="articlesImportConfirmationModal" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <h1 className="modal-title" id="articlesImportConfirmationModalLabel"><span className="icon"></span><span className="text">Import Base Articles</span></h1>
                </Modal.Header>
                <Modal.Body>
                    <p>Vous souhaitez importer une nouvelle version de la Base Articles&nbsp;:</p>
                    <div className="object articles">
                        <h2>
                            <span className="icon"></span><span className="text">
                                {(fileRef.current?.files !== null && fileRef.current?.files[0] !== undefined) && 
                                (   fileRef.current?.files[0].name)
                                }
                            </span>
                        </h2>
                    </div>
                    <p className="disclaimer">Attention : l'importation d'une nouvelle Base Articles annule et remplace la Base Articles actuellement en place.</p>
                    <p>Veuillez valider l'import de la nouvelle Base Articles.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="btn btn-secondary btn-cancel"
                        data-bs-dismiss="modal"
                        title="Annuler"
                        onClick={handleClose}
                    >
                        <span className="icon"></span>
                        Annuler
                    </Button>
                    <Button
                        className="btn btn-primary btn-ok"
                        data-bs-dismiss="modal"
                        title="Valider"
                        onClick={()=> {handleSubmit()}}
                    >
                        <span className="icon"></span>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}